import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthContext } from "../common/providers/AuthProvider";

const AgentProtectedRoute = ({ children, routeKey }) => {
  const {
    isLogin: { agent },
    user,
    accessToken,
  } = useAuthContext();
  const location = useLocation();
  let services = user?.Services ? user?.Services : [];

  if (agent && accessToken) {
    if (services.includes(routeKey)) {
      return children;
    }
    return (
      <Navigate
        to="/unauthorized"
        state={{ from: location }}
        replace
      />
    );
  }

  return children;
};

export default AgentProtectedRoute;
